angular.module('PatientApp').controller('MyChartSSOCtrl', function($scope, $rootScope, $filter, $state, PatientUsersService){
    
    var _reset = function() {
        // attach this on an obj so 
        // ng-include doesnt attach data to
        // a child scope
        $scope.findData = {};
    };

    _reset();

    // initial state
    $scope.showingCheckEmail = false;
    $scope.showingEmailVerify = false;
    $scope.foundMatch = false;
    $scope.showingNoBills = false;

    $scope.fields = {
        acceptTerms: false,
        email: '',
        verificationCode: ''
    };
    $scope.token = '';
    $scope.userFirstName = '';
    $scope.userLastName = '';

    // listeners
    $rootScope.$on('myChartSSO:showCheckEmail', function(_, token, userFirstName, userLastName) {
        $scope.welcomeMessage = $filter('translate')('myChartSSO.welcomeToPatientWallet', { providerGroupName: $rootScope.brandingConfig.friendlyName });
        $scope.token = token;
        $scope.userFirstName = userFirstName;
        $scope.userLastName = userLastName;
        $scope.showingCheckEmail = true;
    });

    $rootScope.$on('myChartSSO:showNoBills', function(_, token, name) {
        $scope.token = token;
        $scope.welcomeMessage = $filter('translate')('myChartSSO.welcomeToPatientWallet', { providerGroupName: $rootScope.brandingConfig.friendlyName });
        $scope.noBillsPrompt = $filter('translate')('myChartSSO.noBillsPrompt', { patientName: name });
        $scope.showingNoBills = true;
    });

    // functions
    $scope.checkForPatientWalletAccount = function() {
        PatientUsersService.emailAvailable($scope.fields.email)
            .then(function() {
                $scope.showingCheckEmail = false;
                $scope.sendVerification();
                $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.noMatch.prompt', { email: $scope.fields.email });
                $scope.foundMatch = false;
                $scope.showingEmailVerify = true;
            })
            .catch(function() {
                $scope.showingCheckEmail = false;
                $scope.sendVerification();
                $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.foundMatch.prompt', { email: $scope.fields.email });
                $scope.foundMatch = true;
                $scope.showingEmailVerify = true;
            });
    };

    $scope.verifyEmail = function() {
        if ($scope.verifying) {
            return;
        }
        if ($scope.foundMatch) {
            $scope.verifying = true;
            PatientUsersService.confirmSSOVerifyCode($scope.fields.email, $scope.fields.verificationCode, $scope.token)
            .then(function() {
                PatientUsersService.fetchUser().then(function() {
                    $scope.showingEmailVerify = false;
                    $scope.verifying = false;
                    $state.go('app.dashboard', null, {
                        location: 'replace'
                    });
                    $scope.$emit('simpleModal:showPrompt', {
                        header: $filter('translate')('myChartSSO.verifyEmail.foundMatch.success.header'),
                        subcontent: $filter('translate')('myChartSSO.verifyEmail.foundMatch.success.prompt'),
                        intent: 'success',
                        actions: [{
                            label: $filter('translate')('actions.continue'),
                            includeClasses: 'continue-button'
                        }]
                    });
                });
            });
        } else {
            if (!$scope.fields.acceptTerms) {
                // TODO: Add real error here
                return;
            }
            $scope.verifying = true;
            PatientUsersService.registerSSOUser($scope.fields.email, $scope.fields.verificationCode, $scope.fields.acceptTerms, $scope.token)
            .then(function() {
                PatientUsersService.fetchUser().then(function() {
                    $scope.showingEmailVerify = false;
                    $scope.verifying = false;
                    $state.go('app.dashboard', null, {
                        location: 'replace'
                    });
                    $scope.$emit('simpleModal:showPrompt', {
                        header: $filter('translate')('myChartSSO.verifyEmail.noMatch.success.header'),
                        subcontent: $filter('translate')('myChartSSO.verifyEmail.noMatch.success.prompt'),
                        intent: 'success',
                        actions: [{
                            label: $filter('translate')('actions.continue'),
                            includeClasses: 'continue-button'
                        }]
                    });
                });
            });
        }

    };

    $scope.sendVerification = function() {
        PatientUsersService.myChartSSOSendVerification($scope.fields.email, $scope.userFirstName, $scope.token)
            .then(function(resp) {
                $scope.token = resp.data.token;
            });
    };
});
